var $b4e14b6b8da86996$exports = {};
const $b4e14b6b8da86996$var$sendMessageBtn = document.querySelector(".btn-send-message");
const $b4e14b6b8da86996$var$sendEmojiBtn = document.querySelector(".btn-send-emoji");
$b4e14b6b8da86996$var$sendMessageBtn?.addEventListener("click", async ()=>{
    const response = await fetch("/message", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            message: "Tous les dinosaures viennent \xe0 la f\xeate!"
        })
    });
    alert(await response.text());
});
$b4e14b6b8da86996$var$sendEmojiBtn?.addEventListener("click", async ()=>{
    const response = await fetch("/api/emoji", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            emoji: "\uD83E\uDD95"
        })
    });
    alert(await response.text());
});


//# sourceMappingURL=index.27145624.js.map
